import { useGoogleAnalytics } from "@/utils/analyticsUtils";
import { useDocumentTitle } from "@/utils/hooksUtils";
import { Notification } from "@/utils/notificationUtils";
import { App as AntApp } from "antd";
import { Route, Routes } from "react-router";
import { Role } from "../../common/security/enums";
import { useSelectedAccount, useSessionSync } from "../../modules/auth/hooks";
import { useEnumerationsSync } from "../../modules/enumerations/hooks";
import { AppLayout } from "../components/layout/AppLayout";
import { ClientLayout } from "../components/layout/ClientLayout";
import { PublicLayout } from "../components/layout/PublicLayout";
import { ProtectedRoute } from "../components/ProtectedRoute";
import { CompetenceCheckProvider } from "../contexts/CompetenceCheckContext";
import { MenuCollapseProvider } from "../contexts/MenuCollapseContext";
import { agentRoleRoutes, attachmentRoutes, clientRoleRoutes, publicRoutes } from "../routes";

export const App = () => {
  useGoogleAnalytics();
  useDocumentTitle();
  useSessionSync();
  useEnumerationsSync();

  const { notification } = AntApp.useApp();
  Notification.init(notification);

  const selectedAccount = useSelectedAccount();

  return (
    <Routes>
      <Route element={<PublicLayout />}>{publicRoutes}</Route>

      <Route element={<ProtectedRoute />}>
        {attachmentRoutes}

        {selectedAccount.role === Role.AGENT ? (
          <Route
            key={selectedAccount.accountId}
            element={
              <MenuCollapseProvider>
                <CompetenceCheckProvider>
                  <AppLayout />
                </CompetenceCheckProvider>
              </MenuCollapseProvider>
            }
          >
            {agentRoleRoutes}
          </Route>
        ) : (
          <Route key={selectedAccount.accountId} element={<ClientLayout />}>
            {clientRoleRoutes}
          </Route>
        )}
      </Route>
    </Routes>
  );
};
